import * as MUI from "@material-ui/core";
import * as SC from "./Modal.Styled";
import { Flex } from "./Common.Styled";
import { FiX } from "react-icons/fi";
import { joinStrs } from "../utils/functions";

const useStyles = MUI.makeStyles(() => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const Modal = ({ isOpen, onClose, size, title, loading, children, posted, desc }) => {
  const classNames = useStyles();

  const handleClose = () => {
    loading || (onClose && onClose());
  };

  return (
    <MUI.Modal open={isOpen} onClose={handleClose} className={classNames.modal} closeAfterTransition>
      <MUI.Fade in={isOpen}>
        <SC.Paper size={size}>
          <Flex jc="e" className="px-4 py-3">
            <SC.CloseButton type="button" onClick={handleClose} disabled={loading}>
              <FiX />
            </SC.CloseButton>
          </Flex>

          {title && <SC.Title className="px-4 py-3">{title}</SC.Title>}
          {desc && <SC.Description className="px-4 py-3">{desc}</SC.Description>}
          <Flex fd="v" className={joinStrs(!posted && "px-4 py-3", !title && "pt-0")}>
            {children}
          </Flex>
        </SC.Paper>
      </MUI.Fade>
    </MUI.Modal>
  );
};

export default Modal;
